/**
 * The top of the page.
 *
 * A shop sign, and one sentence saying what kind of shop. The badge on the right is
 * doing real work rather than decorating: this page is nearly always seen inside a
 * frame on somebody else's site, and a reader who has just noticed that the frame
 * looks nothing like the page around it should find the reason in the first thing
 * they read rather than in the address bar.
 *
 * The figures underneath are counted from the catalogue rather than typed, because a
 * masthead that says seven yarns while the shelf holds eight is the sort of small lie
 * that makes a reader stop believing the rest of the page.
 */

import { ORIGINS } from '@jig/origins';

import { YARNS } from '../catalogue';

/** The service's own name, and the only place it is spelled out. */
export const HOUSE_NAME = 'Marchmont Yarn Index';

export const Masthead = (): JSX.Element => {
  const weights = new Set(YARNS.map((yarn) => yarn.weight));

  return (
    <header className="masthead" data-region="masthead">
      <div className="masthead__sign">
        <p className="eyebrow masthead__house">{HOUSE_NAME}</p>
        <h1 className="masthead__title">
          Every yarn on the shelf, measured rather than described
        </h1>
        <p className="masthead__lead">
          An independent yarn database: ball band ranges as the spinner prints them, the
          gauge our own swatches came out at, and what knitters wrote in afterwards.
        </p>
        <p className="masthead__figures">
          <span className="num">{YARNS.length}</span> yarns,{' '}
          <span className="num">{weights.size}</span> weights, a measured swatch for every
          one.
        </p>
      </div>

      <p className="masthead__badge">
        <span className="masthead__badge-word">Second origin</span>
        <span className="masthead__badge-origin num">{ORIGINS.yarns}</span>
      </p>
    </header>
  );
};
